'use strict';

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _WixSdkWrapper = require('@wix/photography-client-lib/dist/src/sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaApi = function () {
  function MediaApi() {
    (0, _classCallCheck3.default)(this, MediaApi);
  }

  (0, _createClass3.default)(MediaApi, [{
    key: 'openFileMediaDialog',
    value: function openFileMediaDialog() {
      return new _promise2.default(function (resolve, reject) {
        _WixSdkWrapper2.default.Dashboard.openMediaDialog(_WixSdkWrapper2.default.Settings.MediaType.DOCUMENT, false, function (data) {
          var mediaBaseUrl = 'https://static.wixstatic.com/';
          var urlObj = (0, _urijs2.default)(mediaBaseUrl).path(data.fileUrl);
          resolve({ url: urlObj.toString(), fileName: data.title });
        }, function () {
          reject();
        });
      });
    }
  }]);
  return MediaApi;
}();

module.exports = new MediaApi();